import React, { Fragment } from 'react'
import { FormWrapper, FormSubmit } from '@myxplor/forms'

export const ProviderLevelReportDone = ({ resetCurrentReport, children }) => (
  <div className="reportForm--success">
    <FormWrapper
      onSubmit={resetCurrentReport}
      render={() => (
        <Fragment>
          {children}

          <FormSubmit>Done</FormSubmit>
        </Fragment>
      )}
    />
  </div>
)



// WEBPACK FOOTER //
// ./src/provider-level/reports/views/done.jsx